"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var EventInfo = /** @class */ (function () {
    function EventInfo() {
        this.name = '';
        this.price = 0;
        this.sub_title = '';
        this.description = '';
        this.image = null;
        this.place = { name: '', coordinates: {}, address: {} };
        this.maxAttendees = 0;
        this.dates = [];
        this.subscription_date = {};
        this.accept_term = '';
    }
    Object.defineProperty(EventInfo.prototype, "formatted_event_date", {
        get: function () {
            return utils_1.formatDate(this.dates[0]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventInfo.prototype, "formatted_subscription_date", {
        get: function () {
            return utils_1.formatDate(this.subscription_date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventInfo.prototype, "date", {
        get: function () {
            if (!this.dates.length)
                return {};
            var datesSortered = new Array()
                .concat(this.dates)
                .sort(function (_a, _b) {
                var endA = _a.end;
                var endB = _b.end;
                return new Date(endA).getTime() - new Date(endB).getTime();
            });
            var minDate = datesSortered[0];
            var maxDate = datesSortered[datesSortered.length - 1];
            return {
                start: minDate.start,
                end: maxDate.end
            };
        },
        set: function (dateRange) {
            this.dates = [dateRange];
        },
        enumerable: true,
        configurable: true
    });
    return EventInfo;
}());
exports.EventInfo = EventInfo;
//# sourceMappingURL=event-info.js.map